import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { site, orari, footer } = useContent();

  return (
    <footer data-testid="site-footer" className="bg-olive-900 border-t border-sand-50/10 text-sand-100/70 noise-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="w-12 h-12 rounded-full overflow-hidden bg-sand-50 shrink-0">
              <img src="/logo.png" alt={`Logo ${site.name}`} className="w-full h-full object-cover" />
            </span>
            <p className="font-serif text-2xl text-sand-50">{site.name}</p>
          </div>
          <p className="mt-4 text-sm font-light leading-relaxed">{footer.tagline}</p>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-[0.18em] uppercase text-sand-100/40 mb-4">Contatti</p>
          <p className="text-sm font-light leading-relaxed">{site.address}</p>
          <p className="mt-2 text-sm font-light">{site.phone}</p>
          <p className="mt-1 text-sm font-light">{site.email}</p>
        </div>
        <div>
          <p className="text-xs font-semibold tracking-[0.18em] uppercase text-sand-100/40 mb-4">Orari</p>
          {orari.rows.map((o) => (
            <p key={o.giorni} className="text-sm font-light leading-relaxed">
              <span className="text-sand-100/90">{o.giorni}:</span> {o.orari}
            </p>
          ))}
        </div>
      </div>
      <div className="border-t border-sand-50/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs font-light text-sand-100/40">
          <span>© {new Date().getFullYear()} {site.name}</span>
          <span>{footer.bottom}</span>
        </div>
      </div>
    </footer>
  );
}
